import React from 'react';

const WaterIcon = ({ size = 100, color = 'black', strokeWidth = 1.5 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 5 10 L 7 21 H 17 L 19 10"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M 5 14 C 9 12, 15 16, 19 14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 4.5C9.5 3.67157 10.1716 3 11 3C11.8284 3 12.5 3.67157 12.5 4.5C12.5 5.5 11 7 11 7C11 7 9.5 5.5 9.5 4.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 2.5C13.5 1.67157 14.1716 1 15 1C15.8284 1 16.5 1.67157 16.5 2.5C16.5 3.5 15 5 15 5C15 5 13.5 3.5 13.5 2.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WaterIcon;
